export const getServiceRateParams = (data) => {
  const {startDateFilter, endDateFilter, type, icc, iccGroup, dealer, requestType} = data;
  return {
    'itemsType': type,
    'dateFrom': startDateFilter,
    'dateTo': endDateFilter,
    dealer,
    icc,
    iccGroup,
    requestType,
  };
};

export const parseIccGroup = (options = {}) => {
  const optionsValue = options || {};
  return Object.keys(optionsValue).map((icc) => {
    return {'text': icc, 'value': icc};
  });
};

export const parseIcc = (options = {}) => {
  const optionsValue = options || {};
  return Object.values(optionsValue)
    .flat()
    .map((icc) => {
      return {'text': icc, 'value': icc};
    });
};
